import React from "react";
import Seo from "../components/Seo";
import Footer from "../components/Footer";
import Hero from "../components/Heros/HeroBusiness";
import Cta from "../components/Cta";
import Feature from "../components/Features/FeatureSalesforce";


const SalesForce = () => (
    <>
        <Seo
            title="Salesforce 디지털 트랜스포메이션"
            description="Sales·Service·Marketing Cloud 구축부터 360 Views 데이터 통합, Tableau BI, Agentforce AI까지 Salesforce 기반 디지털 전환을 제공합니다."
            path="/dt"
        />
        <Hero />
        <Feature />
        <Cta preset="contact" product="Salesforce" />
        <Footer />
    </>
);

export default SalesForce;
